import { get_axios_instance, api_variables,api_nest_variables, get_axios_nest_instance, errorHandler, get_axios_nest_regenerate_instance, api_regenerate_report_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_PAYROLL_LOCK_UNLOCK);
var axios_instance_total_pay = get_axios_instance(api_variables.SERVICE_EMPLOYEES_TOTALPAY);
var axios_instance_total_month = get_axios_instance(api_variables.SERVICE_PAYROLL_MONTH);
var axios_instance_release_payslip = get_axios_instance(api_variables.SERVICE_RELEASE_PAYSLIP_ESS);
var axios_instance_statutory_setting_check = get_axios_instance(api_variables.SERVICE_STATUTORY_SETTINGS_CHECK);
var axios_instance_get_payroll_details = get_axios_instance(api_variables.SERVICE_GET_PAYROLL_DETAILS);
var axios_instance_fetch_declaration_flag = get_axios_instance(api_variables.SERVICE_IT_PROOF_RELEASE_DECLARATION_FLAG);
var axios_instance_incorporate_declaration = get_axios_instance(api_variables.SERVICE_IT_PROOF_INCORPORATE_DECLARATION);
var axios_instance_select_all_payroll= get_axios_instance(api_variables.SERVICE_SELECT_ALL_PAYROLL);
var axios_instance_release_it_sheet = get_axios_instance(api_variables.SERVICE_RELEASE_IT_SHEET_ESS)
var axios_instance_payroll_report_generation_flag = get_axios_instance(api_variables.SERVICE_PAYROLL_REPORT_GENERATION_FLAG)
var axios_instasnce_generate_payroll_reports = get_axios_nest_regenerate_instance(api_regenerate_report_variables.SERVICE_GENERATE_PAYROLL_REPORTS)
var axios_instasnce_release_form_sixten =  get_axios_nest_instance(api_nest_variables.SERVICE_RELEASE_FORM_SIXTEEN)

const _pk_name = "id";

const state = {
    data: [],
    totalPay: {},
    entityWiseData: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setTotalPayData: (state, payload) => {
      state.totalPay = payload;
    },

    setEditMode: (state, payload) => {
        //console.log("payload---", payload.record);
        state.editMode = payload.editMode;
        state.record = payload.record;
    },
    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
        //console.log('fetched exits', state.exits)
    },

    addEmployee: (state, payload) => {
        //console.log('payload data from store', payload)
        state.exits = payload;
        //console.log('exit data', state.exits);
        //console.log('state data', state.data);
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
  async lock({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    } catch (err){
      throw errorHandler(err.response);
    }
  },

  async unlock({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    } catch (err){
        //console.log(err);
    }
  },

  async getTotalPay({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_total_pay.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },
  async getDeclarationFlag({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_fetch_declaration_flag.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        // commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },
  async incorporateDeclaration({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_incorporate_declaration.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        // commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },
  async getSelectAllItemsPayroll({commit}, payload) {
    //console.log("[state/payroll/monthlypayroll/getLockedPayrollMonth] Adding...", payload);
  try {
    commit("setSaving", true);
    let res = await axios_instance_select_all_payroll.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        // commit("addEmployee", payload);
      }
    return res;
  }catch (err){
      //console.log(err);
  }
},
  async getLockedPayrollMonth({commit}, payload) {
      //console.log("[state/payroll/monthlypayroll/getLockedPayrollMonth] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_total_month.get('/', {
        params: {
          ...payload
        }
      });
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async getStatutorySettingsCheck({commit}, payload) {
  try {
    commit("setSaving", true);
    let res = await axios_instance_statutory_setting_check.get('/', {
      params: {
        le_id: payload
      }
    });
    commit("setSaving", false);
    //console.log("[state/payroll/payGroup/create] res: ", res);

    return res;
  }catch (err){
      //console.log(err);
  }
},

  async releasePayslipESS({ commit }, payload) {
    //console.log("[state/payroll/monthlypayroll/getLockedPayrollMonth] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_release_payslip.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async releaseITSheetESS({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_release_it_sheet.post('/', payload);
      commit("setSaving", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async getPayrollReportGenerationFlag({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_payroll_report_generation_flag.get('/', {
        params: {
          legal_entity_id: payload.legal_entity_id,
          month : payload.month,
          financial_year : payload.financial_year
        }
      });
      commit("setSaving", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async generatePayrollReports({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instasnce_generate_payroll_reports.post('', payload);
      commit("setSaving", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async releaseFormSixten({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instasnce_release_form_sixten.post('', payload);
      commit("setSaving", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async getCurrentPayrollDetails({ commit }, payload) {
    //console.log("[state/payroll/monthlypayroll/getLockedPayrollMonth] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_get_payroll_details.get('/', {
        params: {
          le_id: payload
        }
      });
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      // if (res.status == 200) {
      //   commit("addEmployee", payload);
      // }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
